import type { VodBundleWithContent } from '@setplex/tria-api'
import type { AdjustPurchaseableFn } from '~/features/payment/sse-purchases'
import type {
  UiVodBundleWithContent,
  VodWithPrice,
} from '~/shared/interfaces/vod'

import { t } from '~/core/i18n'
import {
  extendMediaItemByLabelPrice,
  getLabelPriceForPurchasedItem,
} from '~/shared/tools'

// VodWithPrice
export const formatVodBundleWithContentToUi = (
  bundle: VodBundleWithContent | null,
  adjustVod: AdjustPurchaseableFn,
  adjustSet: AdjustPurchaseableFn
): UiVodBundleWithContent | null => {
  if (!bundle) return null
  const adjustedBundle = adjustSet(bundle)
  const { purchaseInfo, vods } = adjustedBundle

  const rentedDuration = getLabelPriceForPurchasedItem({ purchaseInfo })
  const labelRented = rentedDuration
    ? t('rented_to', {
        duration: rentedDuration,
      })
    : ''

  const vodsFormatted = adjustedBundle.purchaseInfo
    ? vods
    : vods.map(
        (vod) =>
          extendMediaItemByLabelPrice(adjustVod(vod), true) as VodWithPrice
      )

  return {
    ...adjustedBundle,
    vods: vodsFormatted,
    labelRented,
  }
}
